import { Scene, SceneLayer, type SceneLayerKind } from "../../controls/Scene.js";
import { addToControls, registerElement, type Attrs } from "../registry.js";

const LAYER_TAGS: Record<string, SceneLayerKind> = {
  Background: "background",
  Stage: "stage",
  Content: "content",
  Foreground: "foreground",
};

export function registerSceneElements(): void {
  registerElement<Scene>({
    tag: "Scene",
    base: "panel",
    docksChildren: true,
    attributes: { design: "size", fit: ["none", "contain", "width"] },
    create: (attrs) => new Scene(attrs as never),
    // A layer element takes its band's place; anything else written straight inside a scene is
    // content, which is what somebody who has not met the layers yet will have meant by it.
    addChild: (scene, child) => {
      if (child instanceof SceneLayer) scene.setLayer(child);
      else scene.contentLayer.controls.add(child);
    },
  });

  for (const [tag, kind] of Object.entries(LAYER_TAGS)) {
    registerElement<SceneLayer>({
      tag,
      base: "panel",
      // An effect alone in a band fills it - a sky, a field of embers - with nothing written.
      docksChildren: true,
      create: (attrs: Attrs) => new SceneLayer(kind, attrs as never),
      addChild: (layer, child) => addToControls(layer, child),
    });
  }
}
